module.exports = __webpack_public_path__ + "img/logo_qclass_ead_png.3e47be92.png";